/**
 * Watcher
 *
 * A class that can watch a given watchable and then respond with callbacks.
 */
export default class Watcher {
  addCallback(/* function */ callbackFn) {
    throw new Error('Subclass should implement addCallback');
  }

  notify(/* Watchable */ watchable, /* WatchedData */ data) {
    throw new Error('Subclass should implement notify');
  }

  removeCallback(/* function */ callbackFn) {
    throw new Error('Subclass should implement removeCallback');
  }

  watch(/* Watchable */ watchable) {
    throw new Error('Subclass should implement watch');
  }
}
